module.exports = __webpack_public_path__ + "static/media/homeS.340945e6.jpg";